import { useQuery } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { codeListGetQuery } from "../../../../../api/index.js";
import { absenceNS, translatedCausecode } from "../../../../../mgmtview/personalprofile/newabscencemodal/newabscencemodal.constants.js";

export const useGetEventTypesOptions = () => {
  const { data } = useQuery(codeListGetQuery("calendarEventTypes"));
  const { t } = useTranslation(absenceNS);

  const getTranslation = useCallback((eventType) => {
    if (eventType.memo === "Other") return t(eventType.codeKey); // FLEXI or HOURS
    return translatedCausecode(eventType.codeKey, t);
  }, [t]);

  const eventTypesOptions = useMemo(
    () =>
      data?.data?.items?.map((eventType) => ({
        value: eventType.codeKey,
        label: getTranslation(eventType),
        paidness: eventType.memo,
      })),
    [data, getTranslation],
  );

  return eventTypesOptions || [];
};
